import axios from "axios";
import MockAdapter from "axios-mock-adapter";
import arrLogFunc, { apiConfig } from "../utils";

const initMockAdapter = api => {
  if (process.env.NODE_ENV === "production") {
    return;
  }

  api.interceptors.response.use(...arrLogFunc);

  const mock = new MockAdapter(api, {
    // delayResponse: 2000
  });

  // mock.onPost('/trade').networkErrorOnce();
  mock
    .onGet("/users")
    .reply(200, {
      users: [{ id: 1, name: "John Smith" }]
    })
    .onAny()
    .passThrough();
};

const api = axios.create({
  baseURL: apiConfig.baseUrlTrade,
  headers: {
    Authorization: `Bearer ${apiConfig.token}`,
    Accept: "application/json"
  },
  timeout: 180000
});

if (apiConfig.reHostname.test(window.location.hostname)) {
  initMockAdapter(api);
}

api.interceptors.request.use(config => {
  config.headers.Authorization = `Bearer ${apiConfig.token}`;
  return config;
});

const getUsers = () => api.get("/users");

const sign = async ({ json = 1, uid = null } = {}) => {
  const resp = await api.get("/sign", {
    params: { json, uid }
  });
  return resp.data;
};

const authorize = async ({
  timestamp,
  signature,
  userType,
  appKey,
  appId,
  appUrl,
  appUid,
  code = ""
}) => {
  const params = {
    timestamp,
    signature,
    "APP-KEY": appKey,
    "APP-ID": appId,
    "APP-URL": appUrl,
    "APP-UID": appUid,
    "REF-CODE": code
  };
  if (userType) {
    params.user_type = userType;
  }

  const resp = await api.post("/authorize", params);
  if (resp.data.errors) {
    const err = new Error();
    err.response = resp;
    throw err;
  } else {
    apiConfig.token = resp.data.access_token;
  }
  return resp.data;
};

export { api, sign, authorize, getUsers };
